// extracted by mini-css-extract-plugin
module.exports = {"caret":"ExpansionIcon_caret__Q6GoL","activeCaret":"ExpansionIcon_activeCaret__0FhWh"};